import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_ROTATION_LIST } from '../urls'
import ManthlyRotationForm from './ManthlyRotationForm'

export default function ManthlyRotationCreate({ onCancel, onSuccess }) {
    const rotationCreate = usePostRequest({ url: MANTHLY_ROTATION_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyRotationForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
